import { useNavigate } from "react-router-dom";
import { MTButton } from "../button/MTButton";

// แสดง fallback เมื่อ URL ไม่ตรงกับ route ใดและพาผู้ใช้กลับหน้าหลักได้
const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <main className="flex min-h-[60vh] flex-col items-center justify-center px-6 text-center font-IBMPlexSansThai">
      <p className="text-5xl font-semibold text-maincyan">404</p>
      <h1 className="mt-4 text-xl font-semibold text-mainblue">
        ไม่พบหน้าที่คุณค้นหา
      </h1>
      <p className="mt-2 max-w-md text-sm text-gray-600">
        URL นี้อาจไม่ถูกต้อง หรือหน้าดังกล่าวอาจถูกย้ายไปแล้ว
      </p>
      <MTButton
        className="mt-6"
        text="กลับหน้าหลัก"
        onClick={() => navigate("/")}
      />
    </main>
  );
};

export default NotFoundPage;
